var map = {
	"./images/Billy.jpg": 23,
	"./images/Rhyme-Detector-screenshot.png": 47,
	"./images/Telegram-Desktop-screenshot.png": 48,
	"./images/Weather-Dashboard-screenshot.png": 49,
	"./images/Work-Day-Scheduler-screenshot.png": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;